// extracted by mini-css-extract-plugin
export default {"section":"PaperSection_section__6zNpg","inverted":"PaperSection_inverted__dYJ2V","editor-container":"PaperSection_editor-container__ud9-u"};